import { useEffect, useState } from 'react';
import { AreaForm } from '../../models/area.model';
import AreaCreateForm from '../AreaCreateForm';
import { getNotifTypes } from '../../services/autocomplete.service';
import { useProject } from '../../context/ProjectContext';


interface AreaCreateProps {
  setBlockScreen: (p: boolean) => void;
}

const AreaCreate: React.FC<AreaCreateProps> = ({ setBlockScreen }) => {
  const { selectedProject } = useProject()
  const [areaForm, setAreaForm] = useState<AreaForm>({
    name: '',
    created_date: '',
    phone_number: '',
    description: '',
    company: { id: '', label: '' },
    notifs: [],
    discords: [],
    emails: [],
  })

  const initComponent = () => {
    setBlockScreen(true)
    Promise.all([getNotifTypes(selectedProject)]).then(function (result: any[]) {
      setAreaForm({
        ...areaForm,
        notifs: result[0]
      });
      setBlockScreen(false)
    })
      .catch((error) => {
        setBlockScreen(false)
      })
  }

  useEffect(initComponent, [])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setAreaForm({
      ...areaForm,
      [event.target.name]: event.target.value
    });
  }

  const handleSelection = (key: string, value: string): void => {
    setAreaForm(areaForm => ({
      ...areaForm,
      [key]: value
    }));
  }

  return (
    <AreaCreateForm
      setBlockScreen={setBlockScreen}
      action='create'
      areaForm={areaForm}
      handleChange={handleChange}
      handleSelection={handleSelection}
    />)
}

export default AreaCreate;